/**
 * ### React-Redux connect wrapper
 *
 * Allows us to unit test connected components without having to do anything custom
 * like exporting the unconnected component and wrapping the mounted component
 * with redux's `Provider`.
 *
 * Simply run:
 * ```
 * connect.setTestProps(mapStateToProps, mapDispatchToProps, mergeProps)
 * ```
 *
 * before mounting with enzyme.
 *
 * @author Richard Scoondog @ 02/02/2018 16:26
 *
 * @todo
 * @author Matthew Rawson @ 15/03/2018 16:30
 * There is a use case for connect settings {withRef: true}. `y` in this case is a stateless function component
 * which can't be given refs. A workaround for this could be to use recompose:
 * https://github.com/acdlite/recompose/blob/master/docs/API.md#toclass
 * n.b. this only effects tests when `__USEMOCKCONNECT__ = true` so I am leaving for now.
 *
 */
import React from "react"
import {connect as RRConnect} from "react-redux"

let testMstp = {}
let testActions = {}

export const connect = (mstp, actions, extra, options) => {
  if (global && global.__USEMOCKCONNECT__) {
    return (C) => {
      function y(props) {
        return <C {...testMstp} {...testActions} {...props} />
      }
      y.contextTypes = C.contextTypes
      return y
    }
  }
  return RRConnect(mstp, actions, extra, options)
}

connect.setTestProps = (mstp, actions) => {
  testMstp = mstp
  testActions = actions
}

export default connect
